// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7XFQh","importantInfo":"styles_importantInfo__E-FE6"};